import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { CircularProgress, Box, Typography } from '@mui/material';
import SalesHistoryList from '../../../components/chancemng/sales-history/SalesHistoryList'
import { listSalesHistory } from '../../../modules/chanceModule/sales-history';

const SalesHistoryListContainer = () => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const { history, chance, error, loading } = useSelector(
        ({ chanceModule, loading }) => ({
            chance: chanceModule.chance.chance,
            history: chanceModule.salesHistory.history,
            error: chanceModule.salesHistory.error,
            loading: loading['chance/SALES_HISTORY'],
        }),
    );

    useEffect(() => {
        dispatch(listSalesHistory(chance?.prjUuid));
    }, [dispatch, chance]);


    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress />
            </Box>
        )
    }

    if (!loading && (!history || history.length === 0)) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Typography variant="body2" component="div">등록된 영업이력이 없습니다.</Typography>
            </Box>
        )
    }

    return (
        <SalesHistoryList data={history} />
    )
}

export default SalesHistoryListContainer